import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StethoscopeIcon, ShieldCheckIcon, ClipboardListIcon, UserCheckIcon, CalendarIcon, HeartIcon } from 'lucide-react';
export function ValueProps() {
  const values = [{
    icon: <StethoscopeIcon className="w-6 h-6 text-primary" data-id="element-260" />,
    title: 'Clinically Skilled Nursing Leadership',
    description: 'Expert oversight ensuring the highest standards of medical and personal care.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-primary" data-id="element-261" />,
    title: 'RN-Supervised Care',
    description: 'RN-supervised care for safety and excellence in every aspect of our service.'
  }, {
    icon: <ClipboardListIcon className="w-6 h-6 text-primary" data-id="element-262" />,
    title: 'Individualized Care Plans',
    description: "Personalized care plans tailored specifically to each client's unique needs."
  }, {
    icon: <UserCheckIcon className="w-6 h-6 text-primary" data-id="element-263" />,
    title: 'Licensed and Certified Professional Caregivers',
    description: 'Highly trained professionals who meet all state requirements for certification and clinical excellence.'
  }, {
    icon: <CalendarIcon className="w-6 h-6 text-primary" data-id="element-264" />,
    title: 'Flexible Scheduling',
    description: "Flexible scheduling options designed to fit seamlessly into your family's life."
  }, {
    icon: <HeartIcon className="w-6 h-6 text-primary" data-id="element-265" />,
    title: 'Relationship-Centered Approach',
    description: 'A relationship-centered approach to care that prioritizes emotional well-being.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="about" className="py-20 px-4 bg-warm" data-id="element-266">
      <div className="max-w-7xl mx-auto" data-id="element-267">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-268">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-4" data-id="element-269">
            Why Choose Ambient Solutions?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-neutral-medium" data-id="element-270">
            We help families hire, train, and certify their own loved ones as
            professional caregivers — so your family member can provide the
            care, backed by our clinical expertise.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-271">
          {values.map((value, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 group" data-id="element-272">
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors group-hover:scale-110 duration-300" data-id="element-273">
                {value.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-neutral-dark mb-3" data-id="element-274">
                {value.title}
              </h3>
              <p className="text-neutral-medium leading-relaxed" data-id="element-275">
                {value.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}